import React, { Component } from "react";
import { Link } from "react-router-dom";

import dayjs from "dayjs";
import "dayjs/locale/nl";
import customParseFormat from "dayjs/plugin/customParseFormat";

class Notification extends Component {
  constructor(props) {
    super(props);
    this.state = { modal: false, isLoading: false, data: [] };
  }

  createMarkup(txt) {
    return { __html: txt };
  }
  render() {
    const { data } = this.props;
    const days = data.days_until_expiry;

    const delayedColor = () => {
      dayjs.extend(customParseFormat);

      switch (true) {
        case days <= 1:
          return "text-danger";
        case days <= 2:
          return "text-orange";
        case days <= 4:
          return "text-warning";
        case days <= 7:
          return "text-yellow";
        case days > 7:
          return "text-success";
        default:
          return "text-danger";
      }
    };

    return (
      <Link
        to={`/producten/details/${data.product_id}`}
        className="text-decoration-none"
      >
        <div className={"THT"}>
          <div>
            <div className="THTTitle">
              {data.quantity} x {data.product_name}{" "}
            </div>
            <div className="THTSubs">
              <div className={`THTCurrent ${delayedColor()}`}>
                {dayjs(data.expiry_date, "DD-MM-YYYY")
                  .locale("nl")
                  .format("DD-MM-YYYY")}{" "}
                / nog {days === 1 ? days + " dag" : days + " dagen"}!
              </div>
            </div>
          </div>
          <div>
            <i className="fa fa-regular fa-chevron-right go"></i>
          </div>
        </div>
      </Link>
    );
  }
}

export default Notification;
